module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAGAgMAAADMNjS4AAAAAXNSR0IB2cksfwAAAAlQTFRFAAAAYGrhYGnihDo3sQAAAAN0Uk5TAID/7PezGAAAACFJREFUeJxjYJBaBQErGRiyoMwlDIxQ1qoJDGwwpgN2pQBM4iGylmB15gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/3@2x.png
// module id = vUf0
// module chunks = 1